// extracted by mini-css-extract-plugin
export default {"card":"FeedCardDrag_card__KU8+d","card__drag-icon":"FeedCardDrag_card__drag-icon__ipz9p"};